import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getSessionItem } from "../../utils/helper/session";

export default function AuthenticatedRoute() {
  const location = useLocation();
  const user = getSessionItem("User");
  const token = sessionStorage.getItem("token");

  if (!user || !token) {
    return <Navigate to="/signin" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
